import React from "react";
import PropTypes from "prop-types";

function Switch({ isChecked, ...rest }) {
  return (
    <input
      type="checkbox"
      data-theme="systemSwitchTheme"
      className="toggle toggle-sm"
      checked={isChecked}
      onChange={rest.onChange || (() => {})}
      {...rest}
    />
  );
}

Switch.propTypes = {
  isChecked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default Switch;
